import { Injectable } from '@angular/core';
import { ofType, Actions, createEffect } from '@ngrx/effects';
import { of, throwError } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { EWalletActions, GetWallet, GetWalletSuccess, GetWalletFailure } from '../actions/wallet.actions';
import { PaymentsService } from '../../services/payments.service';
import { WalletPaginatorInterface } from '../../models/wallet.paginator.interface';
import { Store } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import { AbstractEffects } from '../../../shared/abstract.effects';

@Injectable()
export class WalletEffects extends AbstractEffects {

    currentSelectedPage: number = 0;
    totalItemsPerPage: number = 0;

    constructor(
        private actions: Actions,
        private paymentsService: PaymentsService,
        public override store: Store<any>
    ) {
        super(store);
    }

    getWallet = createEffect(() => this.actions.pipe(
        ofType<GetWallet>(EWalletActions.GetWallet),
        tap(params => {
            this.currentSelectedPage = params.currentSelectedPage;
            this.totalItemsPerPage = params.totalItemsPerPage;
        }),
        switchMap(() => this.paymentsService.getWallet(this.currentSelectedPage, this.totalItemsPerPage)),
        switchMap((response: WalletPaginatorInterface) => of(new GetWalletSuccess(response))),
        catchError((error: HttpErrorResponse) => {
            if (401 === error.status || 403 === error.status) {
                this.ResendRequestWithNewToken(new GetWallet(this.currentSelectedPage, this.totalItemsPerPage));
            } else {
                this.DisplayMessage('error_with_retry', 400, new GetWalletFailure());
            }
            return throwError(error);
        })
    ));
}
